import { useEffect, useState } from 'react';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { Models } from '../../../Utils/ModelsCarBooking';
import axios from 'axios';

const EMPTY = {
  idVehiculo: 0,
  tipo: '',
  descripcion: '',
  fechaProgramada: '',
  fechaReal: '',
  costo: '',
  km: '',
  activo: true,
};

const endpointVehiculo = ENDPOINTS.vehiculo;
const modeloVehiculo = Models.vehiculo;

export default function Modal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({
    idVehiculo: '',
    tipo: '',
    descripcion: '',
    fechaProgramada: '',
    fechaReal: '',
    costo: '',
    km: '',
  });

  // catálogo de vehículos
  const [vehiculos, setVehiculos] = useState([]);
  const [loadingVehiculos, setLoadingVehiculos] = useState(false);
  const [errorVehiculos, setErrorVehiculos] = useState(null);

  const validateField = (field, rawValue) => {
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    let error = '';

    switch (field) {
      case 'idVehiculo':
        if (!value || Number(value) <= 0) error = 'Selecciona un vehículo.';
        break;
      case 'tipo':
        if (!value) error = 'El tipo es obligatorio.';
        break;
      case 'descripcion':
        if (!value) error = 'La descripción es obligatoria.';
        break;
      case 'fechaProgramada':
        if (!value) error = 'La fecha programada es obligatoria.';
        break;
      case 'fechaReal':
        // Opcional? El usuario dijo "any field that is not a checkbox must be made mandatory".
        // Asumiré que fechaReal también es obligatoria si no es checkbox.
        if (!value) error = 'La fecha real es obligatoria.';
        break;
      case 'costo':
        if (value === '' || value === null || value === undefined) error = 'El costo es obligatorio.';
        break;
      case 'km':
        if (value === '' || value === null || value === undefined) error = 'El kilometraje es obligatorio.';
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [field]: error }));
    return !error;
  };

  const validateAll = () => {
    const fields = ['idVehiculo', 'tipo', 'descripcion', 'fechaProgramada', 'fechaReal', 'costo', 'km'];
    let isValid = true;
    fields.forEach(f => {
      if (!validateField(f, form[f])) isValid = false;
    });
    return isValid;
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    validateField(field, value);
  };

  useEffect(() => {
    if (mode === 'edit' && data) {
      const filled = {
        idMantenimiento: data.idMantenimiento ?? 0,
        idVehiculo: data.idVehiculo ?? 0,
        tipo: data.tipo ?? '',
        descripcion: data.descripcion ?? '',
        fechaProgramada: (data.fechaProgramada ?? '').slice(0, 10),
        fechaReal: (data.fechaReal ?? '').slice(0, 10),
        costo: data.costo ?? '',
        km: data.km ?? '',
        activo: data.activo ?? true,
      };
      setForm(filled);
      validateField('idVehiculo', filled.idVehiculo);
      validateField('tipo', filled.tipo);
      validateField('descripcion', filled.descripcion);
      validateField('fechaProgramada', filled.fechaProgramada);
      validateField('fechaReal', filled.fechaReal);
      validateField('costo', filled.costo);
      validateField('km', filled.km);
    } else {
      setForm(EMPTY);
      setErrors({ idVehiculo: '', tipo: '', descripcion: '', fechaProgramada: '', fechaReal: '', costo: '', km: '' });
    }
  }, [mode, data]);

  // cargar vehículos cuando se abre el modal
  useEffect(() => {
    if (!open) return;

    let canceled = false;

    async function loadVehiculos() {
      setLoadingVehiculos(true);
      setErrorVehiculos(null);
      try {
        const res = await axios.get(endpointVehiculo);
        const vehsNorm = (res.data || []).map((x) => modeloVehiculo(x));
        if (!canceled) {
          setVehiculos(vehsNorm);
        }
      } catch (err) {
        console.error('Error cargando vehículos para mantenimiento', err);
        if (!canceled) {
          setErrorVehiculos('No se pudieron cargar los vehículos.');
        }
      } finally {
        if (!canceled) {
          setLoadingVehiculos(false);
        }
      }
    }

    loadVehiculos();

    return () => {
      canceled = true;
    };
  }, [open]);

  if (!open) return null;

  const hasErrors = Object.values(errors).some((e) => !!e);
  const isSaveDisabled =
    !form.idVehiculo ||
    !form.tipo?.trim() ||
    !form.descripcion?.trim() ||
    !form.fechaProgramada ||
    !form.fechaReal || // Asumiendo obligatorio
    form.costo === '' ||
    form.km === '' ||
    hasErrors;

  const errorStyle = {
    color: '#b91c1c',
    fontSize: '.8rem',
    display: 'block',
    marginTop: '4px',
  };

  // etiqueta amigable del vehículo (placa + marca/modelo/año)
  function labelVehiculo(v) {
    if (!v) return '';
    const placa = v.placa || 'S/placa';
    const marca = v.marca || '';
    const modelo = v.modelo || '';
    const anio = v.anio || '';

    const detalle = [marca, modelo, anio].filter(Boolean).join(' ');
    return detalle ? `${placa} · ${detalle}` : placa;
  }

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nuevo mantenimiento' : 'Editar mantenimiento'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '12%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>

      {/* Vehículo (select por placa/marca/modelo/año) */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Vehículo:</label>
        <br /><br />
        <select
          className={`infoField${errors.idVehiculo ? ' infoField--error' : ''}`}
          value={form.idVehiculo || 0}
          onChange={(e) => handleChange('idVehiculo', Number(e.target.value) || 0)}
        >
          <option value={0} disabled>
            {loadingVehiculos ? 'Cargando vehículos…' : 'Seleccione un vehículo…'}
          </option>
          {vehiculos.map((v) => (
            <option key={v.idVehiculo} value={v.idVehiculo}>
              {labelVehiculo(v)}
            </option>
          ))}
        </select>
        {errors.idVehiculo && <small style={errorStyle}>{errors.idVehiculo}</small>}
        {errorVehiculos && (
          <p
            style={{
              color: '#b91c1c',
              fontSize: '.8rem',
              marginTop: '.25rem',
            }}
          >
            {errorVehiculos}
          </p>
        )}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Tipo:</label>
        <br /><br />
        <select
          className={`infoField${errors.tipo ? ' infoField--error' : ''}`}
          value={form.tipo}
          onChange={(e) => handleChange('tipo', e.target.value)}
        >
          <option value="">Seleccione tipo...</option>
          <option value="VERIFICACION">VERIFICACION</option>
          <option value="CORRECTIVO">CORRECTIVO</option>
          <option value="PREVENTIVO">PREVENTIVO</option>
          <option value="OTRO">OTRO</option>
        </select>
        {errors.tipo && <small style={errorStyle}>{errors.tipo}</small>}
      </div>

      <div style={{ gridColumn: '1 / 3' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Descripción:</label>
        <br /><br />
        <textarea
          className={`infoField${errors.descripcion ? ' infoField--error' : ''}`}
          value={form.descripcion}
          onChange={(e) => handleChange('descripcion', e.target.value)}
          rows={3}
          maxLength={500}
        />
        {errors.descripcion && <small style={errorStyle}>{errors.descripcion}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Fecha programada:</label>
        <br /><br />
        <input
          className={`infoField${errors.fechaProgramada ? ' infoField--error' : ''}`}
          type="date"
          onKeyDown={(e) => e.preventDefault()}
          value={form.fechaProgramada}
          onChange={(e) => handleChange('fechaProgramada', e.target.value)}
          onBlur={(e) => validateField('fechaProgramada', e.target.value)}
        />
        {errors.fechaProgramada && <small style={errorStyle}>{errors.fechaProgramada}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Fecha real:</label>
        <br /><br />
        <input
          className={`infoField${errors.fechaReal ? ' infoField--error' : ''}`}
          type="date"
          onKeyDown={(e) => e.preventDefault()}
          value={form.fechaReal}
          onChange={(e) => handleChange('fechaReal', e.target.value)}
          onBlur={(e) => validateField('fechaReal', e.target.value)}
        />
        {errors.fechaReal && <small style={errorStyle}>{errors.fechaReal}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Costo:</label>
        <br /><br />
        <input
          className={`infoField${errors.costo ? ' infoField--error' : ''}`}
          type="number"
          step="any"
          value={form.costo}
          onChange={(e) => handleChange('costo', e.target.value)}
        />
        {errors.costo && <small style={errorStyle}>{errors.costo}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>KM:</label>
        <br /><br />
        <input
          className={`infoField${errors.km ? ' infoField--error' : ''}`}
          type="number"
          step="any"
          value={form.km}
          onChange={(e) => handleChange('km', e.target.value)}
        />
        {errors.km && <small style={errorStyle}>{errors.km}</small>}
      </div>

      {/* 👇 Campo "Activo" eliminado de la UI, pero form.activo sigue existiendo */}
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => {
          if (validateAll()) onSubmit(form, mode);
        }}
        disabled={isSaveDisabled}
        style={{
          opacity: isSaveDisabled ? 0.5 : 1,
          cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(900px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
